export default __webpack_public_path__ + "static/media/scoreRating_pass_bg.e30ae01a.png";